export default class videoPlayer {
    /*
     * Fires first
     */
    constructor() {
        // Add events
        this.addEvents();  
    }

    /*
     * Add events
     */
    addEvents() {
         //Custom play button
        $('.js-video-element__play').on('click', e => { 
            
            let $video = $(e.currentTarget).closest('.js-video-element').find('.js-video-element__video'); 
             
             if ($video[0].paused){
                $video[0].play(); 
                $('.js-video-element__play').hide();
                $video.attr('controls',true);
            }else{
                $video[0].pause();
                $('.js-video-element__play').show();
                $video.attr('controls',false);
            }  
         }); 

         $('.js-video-element__video').on('ended',function(){
            $('.js-video-element__play').show();
            $('.js-video-element__video').attr('controls',false);
        });

        $('.js-video-element__video').on('pause',function(){
            $('.js-video-element__play').show();
            $('.js-video-element__video').attr('controls',false);
        });



    }
}